module.exports = __webpack_public_path__ + "static/media/sj.ae547dbe.svg";